import { Injectable } from '@angular/core';
import { HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../shared/services/localstorage.service';
import { CurrentUser } from 'app/shared/modals/dashboard/currentUser';
import { tap } from 'rxjs/operators';

@Injectable()
export class SetAuthorizationInterceptor implements HttpInterceptor {

  currentUser!: CurrentUser;

  constructor(private localStorageService: LocalStorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (event.headers.get('set-authorization')) {
          this.localStorageService.setLocalDataStr('jwtToken', event.headers.get('Set-Authorization') || '');
        }
        if(event.headers.get('RedirectURL')) {
          this.localStorageService.setLocalDataStr('RedirectUrl', event.headers.get('RedirectURL') || '')
        }
        event = event.clone({ body: event.body, headers: event.headers, status: event.status });
      }
      return event;
    }));
  }
}
